module.exports = __webpack_public_path__ + "img/HITACHI.4b338fef.jpg";